module.exports = __webpack_public_path__ + "img/Training Guide Entrepreneurship lab 10.10_22-min.7aec64e9.png";